import { RouterLink } from '@/components'
import { COMMERCIAL_PHONE } from '@/constants/phones'
import { routes } from '@/router'
import { ArrowForward } from '@mui/icons-material'
import { Box, Button, Stack, Typography } from '@mui/material'

function ArrowItem({ children }: { children: React.ReactNode }) {
  return (
    <Box display="flex" alignItems="flex-start" gap={1}>
      <ArrowForward />
      <span>{children}</span>
    </Box>
  )
}

export function SignUpPage() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: 4,
      }}
    >
      <Box
        display="flex"
        maxWidth={360}
        justifyContent="center"
        flexDirection="column"
        gap={4}
      >
        <Stack spacing={2}>
          <Typography variant="h2" style={{ fontWeight: 300, lineHeight: 1.4 }}>
            Cuidamos da sua <strong>contabilidade</strong> para que você posso
            focar no que importa: <br />
            <strong>seus pacientes</strong>
          </Typography>
        </Stack>
        <Stack spacing={2}>
          <ArrowItem>
            Planos a partir de <strong>R$179/mês</strong>
          </ArrowItem>
          <ArrowItem>
            Abra sua CNPJ <strong>grátis</strong>
          </ArrowItem>
          <ArrowItem>
            Resolva tudo por <strong>WhatsApp</strong>
          </ArrowItem>
          <ArrowItem>
            Emita <strong>notas fiscais</strong>
          </ArrowItem>
          <ArrowItem>
            Pague o <strong>mínimo de impostos</strong>
          </ArrowItem>
          <ArrowItem>
            <strong>Atendimento humanizado</strong> que te apóia em toda sua
            carreira
          </ArrowItem>
        </Stack>
        <Stack spacing={2}>
          <Button
            variant="contained"
            size="large"
            fullWidth
            component="a"
            href={`https://api.whatsapp.com/send?phone=${COMMERCIAL_PHONE}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Quero conhecer
          </Button>
          <Button
            variant="outlined"
            size="large"
            fullWidth
            component={RouterLink}
            to={routes.session.signin}
          >
            Voltar
          </Button>
        </Stack>
      </Box>
    </Box>
  )
}
